import TextField from '@mui/material/TextField'
import { styled } from '@mui/material/styles'

export const StyledTextField = styled(TextField)`
  &:not(:last-child) {
    margin-right: 10px;
  }
`
